import { roles } from "@/components/participant-header/lib/roles";

import isRelativePath from "./is-relative-path";

const ADMIN_ROLES: string[] = [
  roles.PlatformAdmin,
  roles.SiteAdmin,
  roles.HubAdmin,
  roles.ProjectAdmin
];

/** Mirrors ehqv2 SessionsController#dashboard_url_for / Site#dashboard_url. */
export function getPostLoginRedirectPath({
  roleName,
  nextPageUrl,
  host
}: {
  roleName?: string | null;
  nextPageUrl?: string | null;
  host?: string | null;
}): string {
  if (!roleName || !ADMIN_ROLES.includes(roleName)) {
    if (nextPageUrl && isRelativePath(nextPageUrl)) {
      return nextPageUrl;
    }
    return "/";
  }

  const onPlatformSite =
    typeof host === "string" && host.toLowerCase().startsWith("platform.");

  if (roleName === roles.PlatformAdmin && onPlatformSite) {
    return "/platform/sites";
  }

  return "/adm";
}
